import { Component, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { FirebaseError } from 'firebase';
// import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: [ './register.component.scss' ]
})
export class RegisterComponent implements OnDestroy {
  readonly formGroup: FormGroup;
  readonly email: AbstractControl;
  readonly password: AbstractControl;
  readonly fullname: AbstractControl;
  readonly subscriptions: Subscription[] = [];
  // readonly version = environment.version;
  submitted = false;
  loading = false;
  error: string | undefined;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly fb: FormBuilder) {
    this.formGroup = this.fb.group({
      email: [ '', [ Validators.required, Validators.email ] ],
      password: [ '', [ Validators.required ] ],
      fullname: [ '', [ Validators.required ] ],
    });

    this.email = this.formGroup.controls[ 'email' ];
    this.password = this.formGroup.controls[ 'password' ];
    this.fullname = this.formGroup.controls[ 'fullname' ];

  }

  goToPage() {
    this.router.navigate(['/picker'], {skipLocationChange: true});
  }

  register(event: Event): void {
    event.preventDefault();
    this.submitted = true;


    if (this.formGroup.invalid) {
      return;
    }

    this.loading = true;
    this.authService.register(this.email.value, this.password.value)
      .then(() => {
        this.loading = false;
        this.router.navigate(['/picker'], {skipLocationChange: true});
     })
      .catch((error: FirebaseError) => {
        this.error = error.message;
        this.loading = false;
      });

    // this.subscriptions.push(
    //   this.authService.login(this.formGroup.value)
    //     .subscribe(
    //       () => {
    //         this.router.navigate([ '/' ]);
    //       },
    //       error => this.error = error,
    //       () => this.loading = false
    //     )
    // );
  }

  clearError(): void {
    this.error = undefined;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
